import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-background-400 mb-4">
                <a href="#categories-section" className="hover:text-background-200 transition-colors">Categories</a>
              </h4>
              <div className="w-6 h-px bg-background-600 mb-4"></div>
              <ul className="space-y-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm font-body text-background-300 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-background-400 mb-4">
                <a href="#categories-section" className="hover:text-background-200 transition-colors">More Categories</a>
              </h4>
              <div className="w-6 h-px bg-background-600 mb-4"></div>
              <ul className="space-y-2.5">
                {categories.slice(7).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm font-body text-background-300 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-background-400 mb-4">
                <a href="#about-section" className="hover:text-background-200 transition-colors">Resources</a>
              </h4>
              <div className="w-6 h-px bg-background-600 mb-4"></div>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/hipobuy-spreadsheet-guide" className="text-sm font-body text-background-300 hover:text-background-100 transition-colors">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm font-body text-background-300 hover:text-background-100 transition-colors">
                    About This Project
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm font-body text-background-300 hover:text-background-100 transition-colors">
                    Main Website
                  </a>
                </li>
                <li>
                  <Link to="/article/hipobuy-spreadsheet-guide#faq" className="text-sm font-body text-background-300 hover:text-background-100 transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-background-400 mb-4">
                <Link to="/about" className="hover:text-background-200 transition-colors">About</Link>
              </h4>
              <div className="w-6 h-px bg-background-600 mb-4"></div>
              <p className="text-sm font-body text-background-300 leading-relaxed mb-4">
                Hipobuy Spreadsheet is an independent shopping resource hub. We curate and organize product discovery databases to help shoppers find what they need faster.
              </p>
              <p className="text-xs font-body text-background-500">
                &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. All external links open in new tabs.
              </p>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-baseline gap-2">
            <span className="text-2xl md:text-3xl font-heading font-bold text-background-200">Hipobuy</span>
            <span className="text-2xl md:text-3xl font-heading font-light text-background-400">Spread</span>
          </div>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-400 hover:text-background-200 transition-colors">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-global-line"></i>
              </span>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-400 hover:text-background-200 transition-colors">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-bag-line"></i>
              </span>
            </a>
            <span className="text-xs font-body text-background-500">Updated Monthly</span>
          </div>
        </div>
      </div>
    </footer>
  );
}